import React from 'react';
import './App.scss';

import MyHeader from './components/MyHeader';
import TeaserPage from './components/TeaserPage';
import Institutions from './components/TeaserPage/Institutions';
import ConceptsPage from './components/ConceptsPage';
import DemoPage from './components/DemoPage';
import CaseStudiesPage from './components/CaseStudiesPage';
import EvaluationPage from './components/EvaluationPage';
import InvitedPresentationsPage from './components/InvitedPresentationsPage';
import AboutPage from './components/AboutPage';
import WaitingListPage, { WAITING_LIST_URL } from './components/WaitingListPage';
import { VideoModalProvider } from './components/VideoModal';

import { ConfigProvider } from 'antd';
import { Layout } from 'antd';

const { Header, Content, Footer } = Layout;


function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#5B58A5', // https://ant.design/docs/react/customize-theme
          colorSplit: 'rgba(5, 5, 5, 0.06)',
          colorText: '#1F1D33',
          colorBgLayout: 'white', // background
        },
      }}
    >
      <VideoModalProvider>
        <Layout className='app-layout'>
          <Header className='header-div'>
            <MyHeader />
          </Header>
          <Content className='content-div'>
            <main>
              <TeaserPage />
              <ConceptsPage />
              <DemoPage />
              <CaseStudiesPage />
              <EvaluationPage />
              <InvitedPresentationsPage />
              <AboutPage />
              <WaitingListPage />
              <Institutions />
            </main>
          </Content>
          <Footer className='foot'>
            <div className='contain in'>
              <a className='brand' href='#top' aria-label='llm-native figures'><b>llm-native</b><span>figures</span></a>
              <a className='fl' href={WAITING_LIST_URL} target='_blank' rel='noopener noreferrer'>Join the waitlist ↗</a>
              <span className='sp' />
              <span className='note'>© 2024–2026 LLM-Native Figures.</span>
            </div>
          </Footer>
        </Layout>
      </VideoModalProvider>
    </ConfigProvider>
  );
}

export default App;
